import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { showSuccessToast, showWarningToast, showDangerToast } from "../../validation/ToastContainer";
import { PopupContext, TableContext } from "../../index";
import { getDeletePopup, POPUP_TYPES } from "../../view/popup/PopupContainer";
import * as ruleService from "../ruleService";
import { Plus, Trash2 } from "lucide-react";

function ParametersTableHeader({ userCapability }) {

    const initialState = {
        parameterName: null,
        parameterValue: null,
    }

    const history = useHistory();
    const { setPopup } = useContext(PopupContext);
    const [state, setState] = useState(initialState);
    const { config } = useContext(TableContext);

    //#region Set User Capabilities
    const [manageParameterCapability, setManageParameterCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const manageParameterPermission = userCapability.find(item =>
                item.component === "manageparameter" && item.type === "page")?.permission;
            setManageParameterCapability(manageParameterPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion


    const onAddClick = () => setPopup(
        {
            type: POPUP_TYPES.CREATE_PARAMETER,
            parameterName: state.parameterName,
            parameterValue: state.parameterValue,
            confirm: confirmParameterCreation
        }
    );

    const confirmParameterCreation = async (parameterName, parameterValue) => {
        const newParameter = {
            name: parameterName,
            value: parameterValue,
        }

        await ruleService.saveParameter(newParameter)
            .then(success => success && showSuccessToast('Parameter Added Successfully', 'New Parameter'));

        history.go(0);
        setState({ parameterName: null, parameterValue: null });
    }

    const onDeleteClick = () => {
        const onConfirm = async () => {
            if (!config.selected || config.selected.length === 0) {
                return showWarningToast('No selected parameters to delete', 'Remove Parameter', 'aborted');
            }

            ruleService.deleteParameter(config.selected)
                .then((success) => {
                    if (success) {
                        history.go(0);
                        showSuccessToast('Selected parameters were removed', 'Remove Parameter', 'success');
                    } else {
                        showDangerToast('Something went wrong', 'Remove Parameter');
                    }
                });
        }

        setPopup(
            getDeletePopup('Are you sure you want to delete the selected parameters?',
                'Delete Parameter',
                () => onConfirm(),
                undefined,
                'Delete Parameters'
            )
        );
    }

    return (
        <div className="addrules-content-header-v2 parameters-content-header-v2">
            <div className="oct_card-title">
                <h2 className="header-title">Manage Parameters</h2>
                <p className="parameters-content-subtitle-v2">
                    Create reusable values for rule scripts and expected output.
                </p>
            </div>

            <div className="header-actions parameters-header-actions-v2">
                <button
                    className="addrules-btn-save-v2"
                    onClick={manageParameterCapability === 0 ? null : onAddClick}
                    disabled={manageParameterCapability === 0}
                >
                    <Plus />
                    Add Parameter
                </button>

                <button
                    className="addrules-btn-delete-v2"
                    onClick={manageParameterCapability === 0 ? null : onDeleteClick}
                    disabled={manageParameterCapability === 0 || !config.selected?.length}
                >
                    <Trash2 />
                    Delete Selected
                </button>
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(ParametersTableHeader);
